module.exports = __webpack_public_path__ + "img/hero-01.06d1efc3.jpg";